export const ACTIVITY = 'activity';
export const POST = 'post';
export const FANCY_PROMO = 'fancy_promo';
export const PERFORMANCE_GOAL_CREATED = 'performance_goal_created';
export const CHALLENGE = 'challenge';
export const SIMPLE_PROMO = 'simple_promo';
export const GROUP_ACTIVITY = 'group_activity';
export const CLUB = 'club';
